import _ from 'lodash';

const INFO_SEND = 'redux/info/INFO_SEND';
const INFO_DISMISS = 'redux/info/INFO_DISMISS';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INFO_SEND:
      return {
        ...state,
        message: action.payload.message,
        dismissable: action.payload.dismissable,
        onDismiss: action.payload.onDismiss,
      };
    case INFO_DISMISS:
      return {
        ...state,
        message: null,
        dismissable: true,
        onDismiss: null,
      };
    default:
      return state;
  }
}

export function infoSend(message, dismissable = true, onDismiss = _.noop) {
  return {
    type: INFO_SEND,
    payload: {
      message,
      dismissable,
      onDismiss,
    },
  };
}

export function infoDismiss() {
  return {
    type: INFO_DISMISS,
  };
}
